import '../../styles/HistoricalScores';

import ObservationTable from './ObservationTable';
import React, { PropTypes } from 'react';

let HistoricalScores = React.createClass({
	propTypes: {
		fetchObservations: PropTypes.func.isRequired,
		inProgress: PropTypes.func.isRequired,
		observations: PropTypes.array
	},

	contextTypes: {
		router: PropTypes.object.isRequired
	},

	getInitialState: function() {
		return {
			inProgressIds: [],
			isFetching: false
		};
	},

	componentWillMount: function() {
		let promises = [];

		this.setState({ isFetching: true }, () => {
			// Fetch in-progress observations
			promises.push(this.props.inProgress().then((response) => {
				if (response && response.data && response.data.list) {
					this.setState({ inProgressIds: response.data.list.map((observation) => observation.id) });
				}
			}));

			promises.push(this.props.fetchObservations());

			Promise.all(promises).then(() => this.setState({ isFetching: false }));
		});
	},

	getReliabilityObservations: function() {
		return this.props.observations.filter((observation) => {
			const isReliabilityObservation = Boolean(observation.gold_standard_observation_id);
			const isComplete = !this.state.inProgressIds.includes(observation.id);

			return isReliabilityObservation && isComplete;
		});
	},

	render: function() {
		return(
			<div className="gold-standard-observations container">
				<h2>Historical Reliability Scores</h2>
				<h4>Click any observation below to view reliability scores</h4>
				<ObservationTable
					isFetching={ this.state.isFetching }
					items={ this.getReliabilityObservations() }
					handleRowClick={
						(observationID) => this.context.router.push('/observations/' + observationID + '/scores')
					}
					shouldIndicateGoldStandards={ false }
					shouldDisplayGoldStandardId={ true }
				/>
			</div>
		);
	}
});

module.exports = HistoricalScores;



// WEBPACK FOOTER //
// ./frontend/olos/js/components/HistoricalScores.jsx